import styled from 'styled-components';
export const Container = styled.div`
  width: 100%;

  .anticon.anticon-search {
    path {
      color: #8495a8;
    }
    svg {
      margin-top: 0;
    }
  }
`;